import * as React from 'react'
import { FC } from 'react'

export const LongArrowDown: FC = () => (
  <path d="M11.875 10.75L11.6562 10.5C11.5 10.375 11.2812 10.375 11.125 10.5L8.53125 13.125V1.375C8.53125 1.1875 8.34375 1 8.15625 1H7.84375C7.625 1 7.46875 1.1875 7.46875 1.375V13.125L4.84375 10.5C4.6875 10.375 4.46875 10.375 4.3125 10.5L4.09375 10.75C3.9375 10.875 3.9375 11.125 4.09375 11.25L7.71875 14.9062C7.875 15.0625 8.09375 15.0625 8.25 14.9062L11.875 11.25C12.0312 11.125 12.0312 10.875 11.875 10.75Z" />
)

export default LongArrowDown
